import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getMiTrabajoMantenimiento } from "../api";
import { useCliente } from "../context/ClienteContext";
import { MODULE_IDS } from "./moduleIds";
import ModuleHeader from "../components/ui/ModuleHeader";
import "./WorkQueueModule.css";

function formatDate(value) {
  if (!value) return "Sin mantenimientos registrados";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("es-ES");
}

export default function WorkQueueModule() {
  const { seleccionarCliente, setPcActivo, setActiveModule } = useCliente();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [opening, setOpening] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await getMiTrabajoMantenimiento();
      setRows(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setRows([]);
      setError(err?.response?.data?.error || "No se pudo cargar tu trabajo pendiente.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const totals = useMemo(() => rows.reduce((acc, row) => ({
    clients: acc.clients + 1,
    pending: acc.pending + Math.max(0, Number(row.total_equipment || 0) - Number(row.completed_count || 0)),
  }), { clients: 0, pending: 0 }), [rows]);

  const openNext = async (row) => {
    setOpening(row.cliente_id);
    try {
      await seleccionarCliente(row.cliente_id);
      if (row.next_equipment_id) setPcActivo(row.next_equipment_id);
      setActiveModule(MODULE_IDS.MANTENIMIENTOS);
    } finally {
      setOpening(null);
    }
  };

  return (
    <div className="workQueue">
      <ModuleHeader eyebrow="Operación personal" title="Mi trabajo" description="Empieza por el cliente más atrasado y continúa equipo a equipo." actions={<button className="button secondary" type="button" onClick={load} disabled={loading}>{loading ? "Actualizando…" : "Actualizar"}</button>} />
      <section className="workQueue__summary mp-summary-grid">
        <div><span>Clientes pendientes</span><strong>{totals.clients}</strong></div>
        <div><span>Equipos por completar</span><strong>{totals.pending}</strong></div>
      </section>
      {error ? <div className="workQueue__error">{error}</div> : null}
      {!loading && !error && !rows.length ? <div className="workQueue__empty">✅ No tienes mantenimientos pendientes este mes.</div> : null}
      <div className="workQueue__list">
        {rows.map((row) => {
          const total = Number(row.total_equipment || 0);
          const completed = Number(row.completed_count || 0);
          const pending = Math.max(0, total - completed);
          const progress = total ? Math.round((completed / total) * 100) : 0;
          return <article className="workQueue__card mp-section" key={row.cliente_id}>
            <div className="workQueue__cardMain">
              <div className="workQueue__title"><h2>{row.cliente}</h2><span>{pending} pendiente{pending === 1 ? "" : "s"}</span></div>
              <div className="workQueue__progress"><div><i style={{ width: `${progress}%` }} /></div><strong>{completed} de {total}</strong></div>
              <div className="workQueue__meta"><span>Último mantenimiento: {formatDate(row.last_maintenance_at)}</span><span>Siguiente: <b>{row.next_equipment || "—"}</b></span></div>
            </div>
            <button className="btn btn-primary" type="button" onClick={() => openNext(row)} disabled={opening === row.cliente_id}>
              {opening === row.cliente_id ? "Abriendo…" : "Continuar mantenimiento"}
            </button>
          </article>;
        })}
      </div>
    </div>
  );
}
